<template>
	<form @submit.prevent="submit">
		<div v-if="message" class="notification is-light" :class="messageType">
			{{ message }}
		</div>
		<required-field
			:error="$v.email.$error"
			:required="$v.email.required"
			label="Email"
		>
			<input
				v-model.trim="$v.email.$model"
				class="input"
				type="text"
				:class="{ 'is-danger': $v.email.$error }"
			/>
			<p v-if="!$v.email.email" class="help is-danger">
				We require a valid email address
			</p>
		</required-field>
		<div class="buttons mt-5">
			<button
				class="button is-primary is-fullwidth"
				:class="{ 'is-loading': fetching }"
				:disabled="!isValid"
			>
				Reset link
			</button>
		</div>
	</form>
</template>

<script>
import formMixin from "./formMixins";
import { required, minLength, email } from "vuelidate/lib/validators";

export default {
	name: "FormForgottenPassword",
	mixins: [formMixin],
	validations: {
		email: { required, email }
	},
	data() {
		return {
			email: ""
		};
	},
	methods: {
		async submit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				const data = { email: this.email };
				await this.$emit("submit", data);
				this.email = "";
				this.$v.$reset();
			}
		}
	}
};
</script>
